import { SafeUrl } from '@angular/platform-browser';
import { AbstractModel, DateFormatConstants, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { DocumentFieldValue } from './document-field-value';
import { DocumentType } from './document-type';
import { State } from './state';
import { DocumentField } from './document-field';

@inheritSerialization(AbstractModel)
export class Document extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  vehicleId: number;

  @autoserialize
  filename: string;

  @autoserializeAs(DocumentType)
  documentType: DocumentType;

  @autoserialize
  status: string;

  @autoserialize
  number: string;

  @autoserializeAs(DocumentField)
  documentFields: Array<DocumentField>;

  @autoserializeAs(DocumentFieldValue)
  documentFieldValues: Array<DocumentFieldValue>;

  @autoserializeAs(Date)
  expirationDate: Date;

  @autoserializeAs(State)
  state: State;

  @autoserialize
  file: string | SafeUrl;

  @autoserialize
  mimeType: string;

  @autoserialize
  rejected: boolean;

  @autoserialize
  rejectionComments: string;

  @autoserialize
  active: boolean;

  @autoserialize
  approved: boolean;

  @autoserialize
  reviewedByUserId: number;

  @autoserialize
  reviewedBy: string;

  @autoserializeAs(Date)
  lastExpirationReminderDate: Date;

  constructor() {
    super();
    this.mimeType = 'image/jpeg';
  }

  static OnSerialized(instance: Document, json: any): void {
    if (!isNullOrUndefined(instance.expirationDate)) {
      json.expirationDate = DateUtil.serializeLocalDate(instance.expirationDate);
    }
    if (!isNullOrUndefined(instance.lastExpirationReminderDate)) {
      json.lastExpirationReminderDate = DateUtil.serializeLocalDate(instance.lastExpirationReminderDate);
    }
  }

  static OnDeserialized(instance: Document, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['expirationDate'])) {
      instance.expirationDate = DateUtil.deserializeLocalDate(json['expirationDate']);
    }

    if (!isNullOrUndefined(json['lastExpirationReminderDate'])) {
      instance.lastExpirationReminderDate = DateUtil.deserializeLocalDate(json['lastExpirationReminderDate']);
    }
  }
}
